import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_squares",
  "use": "svg_squares-usage",
  "viewBox": "0 0 9 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 8\" id=\"svg_squares\"><path fill=\"currentColor\" d=\"M.5 0h3v3h-3zM.5 5h3v3h-3zM5.5 0h3v3h-3zM5.5 5h3v3h-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol